import clsx from 'clsx';
import React, { useState } from 'react';

import { generateTrackingAttributes } from '@utils/tracking';

import { createLeadLockedHomepage } from '../../application/javascripts/forms/locked-homepage-lead-capture';
import GdprOptIn, { GdprColorScheme } from './GdprOptIn';

interface LeadDetails {
  article_title?: string;
  briefing_title?: string;
  newsletter_name?: string;
  org_chart_title?: string;
  homepage_conversion?: boolean;
  directory_conversion?: boolean;
  project_name?: string;
}

interface LockedLeadCaptureFormProps {
  buttonText: string;
  colorScheme?: GdprColorScheme;
  emailPlaceholderText?: string;
  endpointUri: string;
  forceEmailAuth?: boolean;
  formLocation?: string;
  isGdprLead?: boolean;
  leadDetails?: LeadDetails;
  leadType: string;
  redirectUri: string;
  shareGuid?: string;
  trackingProps?: { [key: string]: string };
}

export default function LockedLeadCaptureForm({
  buttonText,
  colorScheme = 'light',
  emailPlaceholderText = 'Enter your email',
  endpointUri,
  forceEmailAuth = false,
  formLocation,
  isGdprLead = false,
  leadDetails = {},
  leadType,
  redirectUri,
  shareGuid,
  trackingProps = {},
}: LockedLeadCaptureFormProps) {
  const trackClick = Object.keys(trackingProps).length > 0;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.SyntheticEvent) => {
    setIsSubmitting(true);
    e.preventDefault();

    await createLeadLockedHomepage(e);

    setIsSubmitting(false);
  };

  return (
    <div className="lock-lead-capture-form">
      <div className="get-started-form-group">
        <form className="get-started-action-group">
          <input type="text" className="get-started-input" placeholder={emailPlaceholderText} />
          <span className="get-started-btn-container">
            {isGdprLead && <GdprOptIn colorScheme={colorScheme} />}
            <button
              type="submit"
              className={clsx('get-started-button', {
                'track-click': trackClick,
                disabled: isSubmitting,
              })}
              data-submit-uri={endpointUri}
              data-redirect-uri={redirectUri}
              data-lead-type={leadType}
              data-force-email-auth={forceEmailAuth}
              data-lead-details={JSON.stringify(leadDetails)}
              data-form-location={formLocation}
              data-share-guid={shareGuid}
              onClick={handleSubmit}
              {...generateTrackingAttributes({
                name: 'subscribe',
                page: window.location.pathname,
                ...trackingProps,
              })}
            >
              {buttonText}
            </button>
          </span>
        </form>
        <div className="get-started-error"></div>
      </div>
    </div>
  );
}
